<template>
  <div style="width:100%;height:100%">
    <div ref="chart" style="width:100%;height:100%"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'Appointment',
  props: {
    ArtificialInfo: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      myChart: null,
      defaultData: [
        { value: 12, name: '人工干预' },
        { value: 36, name: '现场识别成功' },
      ]
    }
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.dispose();
    }
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    ArtificialInfo: {
      handler(newVal) {
        if (this.myChart) {
          this.updateChart(newVal);
        }
      },
      deep: true
    }
  },
  methods: {
    initChart() {
      if (!this.$refs.chart) return;
      
      if (this.myChart) {
        this.myChart.dispose();
      }
      
      this.myChart = echarts.init(this.$refs.chart);
      this.updateChart(this.ArtificialInfo.length > 0 ? this.ArtificialInfo : this.defaultData);
    },
    
    updateChart(data) {
      if (!this.myChart) return;
      
      // 检查是否所有数据都为0
      const allZero = data.every(item => item.value === 0);
      
      let processedData = [];
      
      if (allZero) {
        // 如果所有数据都为0，保持原样显示0值
        processedData = [...data];
      } else {
        // 过滤掉值为0的项
        processedData = data.filter(item => item.value > 0);
        
        // 根据需求，最多两个数据时保持原样，不做百分比转换
        // 所以这里不需要处理1个或2个数据的特殊情况
        
        // 如果过滤后没有数据（全部值都为0）
        if (processedData.length === 0) {
          processedData = [...data]; // 恢复原始数据，显示0值
        }
      }
      
      const option = {
        title: {
          left: 'center',
          top: 20,
          textStyle: {
            color: '#333',
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            if (allZero || params.value === 0) {
              // 值为0时显示0%
              return `${params.name}: 0%`;
            }
            // 非0值时显示实际值
            return `${params.name}: ${params.value}`;
          }
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 0,
          top: 'center',
          textStyle: {
            color: '#666'
          }
        },
        color: ['#297DEE', '#FFB322', '#FF3E50'],
        series: [
          {
            type: 'pie',
            radius: [20, 90],
            center: ['40%', '50%'],
            roseType: 'area',
            itemStyle: {
              borderRadius: 2,
              borderColor: '#fff',
              borderWidth: 0
            },
            label: {
              show: true,
              formatter: (params) => {
                if (allZero || params.value === 0) {
                  // 值为0时显示0%
                  return `${params.name}: 0%`;
                }
                // 非0值时显示实际值
                return `${params.name}: ${params.value}`;
              }
            },
            labelLine: {
              length: 10,
              length2: 20,
              show: processedData.length > 0 // 没有数据时不显示连接线
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 14,
                fontWeight: 'bold'
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: processedData
          }
        ]
      };
      
      this.myChart.setOption(option, true);
    },
    
    handleResize() {
      if (this.myChart) {
        this.myChart.resize();
      }
    }
  }
}
</script>